import { cx } from '@eti/styles';
import { Heading, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import SeatCharacteristicsPanel from './characteristics/SeatCharacteristicsPanel';
import { asideStyles } from './travelers/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatCharacteristics = ({
  expandedCharacteristicKey,
  onToggle,
  seatCharacteristics,
  shouldRenderInline
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Stack, {
    className: cx(asideStyles.base, {
      [asideStyles.top.noOffset]: !shouldRenderInline,
      [asideStyles.top.withOffset]: shouldRenderInline
    }),
    "data-testid": "seatMap-characteristics",
    id: "seatMap-characteristics",
    as: "aside",
    children: [/*#__PURE__*/_jsx(Heading, {
      level: 3,
      children: t('Product.SeatMap.Characteristics.Label')
    }), /*#__PURE__*/_jsxs(Stack, {
      children: [seatCharacteristics === null || seatCharacteristics === void 0 ? void 0 : seatCharacteristics.map(({
        characteristic,
        price
      }) => /*#__PURE__*/_jsx(SeatCharacteristicsPanel, {
        characteristic: characteristic,
        isOpen: expandedCharacteristicKey === characteristic,
        onToggle: () => onToggle(characteristic),
        priceFrom: price
      }, characteristic)), /*#__PURE__*/_jsx(SeatCharacteristicsPanel, {
        isOpen: expandedCharacteristicKey === 'unavailable',
        isUnavailable: true,
        onToggle: () => onToggle('unavailable')
      })]
    })]
  });
};
export default SeatCharacteristics;
//# sourceMappingURL=SeatCharacteristics.js.map